// День по местному времени строкой `2026-10-25` — так период хранится в URL.
export const toIsoDay = (date: Date): string =>
  [
    String(date.getFullYear()),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0"),
  ].join("-");
